import { IPaginatedResponse } from '@/infra/interfaces/http/http-client';
import { httpClient } from '@/infra/protocols/http';
import { IProjectDTO } from '@/modules/projects/dtos/project.dto';
import { IProject } from '@/modules/projects/entities/project.entity';
import { ProjectMapper } from '@/modules/projects/mappers/project.mapper';

export async function getAllProjects(
  params: GetAllProjectsService.Params,
): Promise<GetAllProjectsService.Response> {
  const response = await httpClient.get<IProjectDTO[], true>(`/v1/projetos/ativos`, {
    params: {
      page: params.page,
      pageSize: params.pageSize,
    },
    paginated: true,
  });

  return {
    ...response,
    data: response.data.map(ProjectMapper.toPresentation),
  };
}

export namespace GetAllProjectsService {
  export type Params = {
    page: number;
    pageSize: number;
  };

  export type Response = IPaginatedResponse<IProject[]>;
}
